import React, { Component, Fragment } from 'react'
// import ScrollAnimation from 'react-animate-on-scroll'

import { MastHead, Preamble, CenterHead } from './'

class HomePage extends Component {
  render () {
    return (
      <Fragment>
        <div className="Home">
         
              <MastHead />          
              <CenterHead/>
             <Preamble />

        </div>
      </Fragment>
    )
  }
}

export default HomePage



// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/Home/components/HomePage.js